import { fetchAllAssets } from '../services/market.service';
import { getTopOffersService } from '../services/top-offers.service';
import {
  FETCH_TOP_OFFERS,
  FETCH_TOP_OFFERS_ASSETS,
  REFRESH_TOP_OFFERS_UPDATE_TOKEN,
  RESET_TOP_OFFERS_DATA,
} from './actionNames/topOffersActionNames';

export const resetTopOffersDataAction = () => ({ type: RESET_TOP_OFFERS_DATA });

export const refreshTopOffersUpdateTokenAction = () => ({ type: REFRESH_TOP_OFFERS_UPDATE_TOKEN });

export const fetchTopOffersAction = (signal: AbortSignal) => ({
  type: FETCH_TOP_OFFERS,
  payload: getTopOffersService(signal),
});

export const fetchTopOffersAssetsAction = (assetsIds: number[]) => ({
  type: FETCH_TOP_OFFERS_ASSETS,
  payload: fetchAllAssets(assetsIds),
});
